module.exports = __webpack_public_path__ + "img/main_ani_bg.f43c1f45.png";